import { useEffect, useState } from 'react';
import { Alert, Center, Loader, Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { oidc } from '../lib/oidc';
import { useSession } from '../lib/session';

/** Where Zitadel sends the parent back to. It exchanges the code, hands the
 * access token to the session, and gets out of the way. */
export function AuthCallbackPage() {
  const { signInParent } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const user = await oidc().signinCallback();
        if (!user?.access_token) throw new Error('Keine Anmeldung erhalten.');
        if (cancelled) return;
        await signInParent(user.access_token, user.profile?.sub ?? '');
        navigate('/eltern', { replace: true });
      } catch (err) {
        if (!cancelled) setError((err as Error).message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [signInParent, navigate]);

  return (
    <Center mih="100vh" p="md">
      {error ? (
        <Alert color="red" variant="light" maw={420}>
          {error}
        </Alert>
      ) : (
        <Stack align="center">
          <Loader />
          <Text size="sm" c="dimmed">
            Anmeldung wird abgeschlossen…
          </Text>
        </Stack>
      )}
    </Center>
  );
}
